export default "__VITE_ASSET__CsjI57pq__"